/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Forgot_LinkInputs */

const en_reset_forgot_link = /** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const ar_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const he_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const ur_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const es_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const fr_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const de_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const pt_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const hi_reset_forgot_link = en_reset_forgot_link;

/** @type {(inputs: Reset_Forgot_LinkInputs) => LocalizedString} */
const bn_reset_forgot_link = en_reset_forgot_link;

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Reset_Forgot_LinkInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_forgot_link = /** @type {((inputs?: Reset_Forgot_LinkInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Forgot_LinkInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_forgot_link(inputs)
	if (locale === "he") return he_reset_forgot_link(inputs)
	if (locale === "ur") return ur_reset_forgot_link(inputs)
	if (locale === "es") return es_reset_forgot_link(inputs)
	if (locale === "fr") return fr_reset_forgot_link(inputs)
	if (locale === "de") return de_reset_forgot_link(inputs)
	if (locale === "pt") return pt_reset_forgot_link(inputs)
	if (locale === "hi") return hi_reset_forgot_link(inputs)
	if (locale === "bn") return bn_reset_forgot_link(inputs)
	return /** @type {LocalizedString} */ ("Forgot your password?")
});